import { createSlice } from '@reduxjs/toolkit';
import {
  LIST_ADMISSIONS_CYCLES,
  SAVE_ADMISSIONS_CYCLE,
} from '../../../actions-index';
import { ERROR_CONSTS } from '../../../util/constants';

const initialState = {
  status: '',
  alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
  data: {},
};

const manageAdmissionsCyclesSlice = createSlice({
  name: 'manageAdmissionsCyclesReducer',
  initialState,
  reducers: {
    listAdmissionsCycles(state, action) {
      return {
        ...state,
        listAdmissionsCyclesData: {
          status: action.payload.status ?? initialState.status,
          alert: action.payload.alert ?? initialState.alert,
          data: action.payload.data ?? initialState.data,
          type: LIST_ADMISSIONS_CYCLES,
        },
      };
    },
    saveAdmissionsCycle(state, action) {
      return {
        ...state,
        saveAdmissionsCyclesData: {
          status: action.payload.status ?? initialState.status,
          alert: action.payload.alert ?? initialState.alert,
          data: action.payload.details ?? initialState.data,
          type: SAVE_ADMISSIONS_CYCLE,
        },
      };
    },
  },
});

export const { listAdmissionsCycles, saveAdmissionsCycle } =
  manageAdmissionsCyclesSlice.actions;
export const manageAdmissionsCyclesReducer = manageAdmissionsCyclesSlice.reducer;
